import { getApiConfig as getSDKApiConfig } from '@lombard.finance/sdk';
import { CURRENT_ENV } from 'modules/common/const';
import { BFF_BASE_URL_PROD, BFF_BASE_URL_STAGE } from './const';

type SDKConfig = ReturnType<typeof getSDKApiConfig>;

interface IApiConfig extends SDKConfig {
  advancedApiUrl: string;
}

const sdkConfig = getSDKApiConfig(CURRENT_ENV);

const stageConfig: IApiConfig = {
  ...sdkConfig,
  advancedApiUrl: `${BFF_BASE_URL_STAGE}/advanced-api/proxy`,
};

const testnetConfig: IApiConfig = {
  ...stageConfig,
};

const prodConfig: IApiConfig = {
  ...sdkConfig,
  advancedApiUrl: `${BFF_BASE_URL_PROD}/advanced-api/proxy`,
};

export const getApiConfig = (env = CURRENT_ENV): IApiConfig => {
  switch (env) {
    case 'prod':
      return prodConfig;
    case 'testnet':
      return testnetConfig;
    default:
      return stageConfig;
  }
};
